import * as S from './GiftCardEmailForm.styles'
import { translateManager as t } from '../../../services/TranslateManager'
import { useState } from 'react'
import DummySubmit from '../../DummySubmit/DummySubmit'
import TextInput from 'mixtiles-web-common/ui/TextInput'
import * as EmailValidator from 'email-validator'

type Props = {
  initialEmail: string | null
  onClose: (newEmailAdded: boolean) => void
  onSubmit: (email: string) => Promise<void>
}

function GiftCardEmailForm({ initialEmail, onClose, onSubmit }: Props) {
  const [email, setEmail] = useState(initialEmail || '')
  const [indicateInvalidInput, setIndicateInvalidInput] = useState(false)

  const handleEmailInputChange = (value: string) => {
    setEmail(value)
  }

  const onDone = async () => {
    if (EmailValidator.validate(email)) {
      await onSubmit(email)
      onClose(true)
    } else {
      setIndicateInvalidInput(true)
    }
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onDone()
  }

  return (
    <S.Container>
      <S.TopBar>
        <S.CloseButton onClick={() => onClose(false)} />
        <S.Title>{t.get('gift_card.form.add_email_address')}</S.Title>
        <S.DoneButton
          onClick={onDone}
          data-testid="add-email-address-done-button"
        >
          {t.get('general.done')}
        </S.DoneButton>
      </S.TopBar>
      <S.Content>
        <form onSubmit={handleSubmit}>
          <S.Label>{t.get('gift_card.your_email')}</S.Label>
          <TextInput
            variant="white"
            fullWidth
            placeholder={t.get('general.menu.add_promo_code.modal.placeholder')}
            value={email}
            onChange={handleEmailInputChange}
            isInvalid={indicateInvalidInput}
            invalidMessage={t.get(
              'general.address_form.validation_errors.email.invalid'
            )}
            testId="gift-card-customer-email-input"
          />
          <DummySubmit />
        </form>
      </S.Content>
    </S.Container>
  )
}

export default GiftCardEmailForm
